import { actionTypes as projectEditorActionTypes } from "Areas/Projects/projectEditorPanel";
import projectsActionTypes from "Areas/Projects/redux/actionTypes";
import workSpacesActionTypes from "Areas/WorkSpaces/redux/actionTypes";
import { actionTypes as editorActionTypes } from "Areas/WorkSpaces/workSpaceEditorPanel";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import findIndex from "lodash/findIndex";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import reject from "lodash/reject";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { workSpaces: undefined }
};
export default createReducer(initialState, {
    [actionTypes.GET_WORK_SPACES_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].workSpaces`, keyBy(payload, "Id")),
    [editorActionTypes.SAVE_WORK_SPACE_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].workSpaces[${payload.Id}]`, payload),
    [projectEditorActionTypes.SAVE_PROJECT_COMPLETED]: (state, { payload }) => {
        var _a, _b;
        const projects = (_b = (_a = state[NAMESPACE].workSpaces) === null || _a === void 0 ? void 0 : _a[payload.WorkSpaceId]) === null || _b === void 0 ? void 0 : _b.Projects;
        if (!projects)
            return state;
        const prevIndex = findIndex(projects, ["Id", payload.Id]);
        const indexToInsertOrUpdate = prevIndex !== -1 ? prevIndex : projects.length || 0;
        return set(state, `[${NAMESPACE}].workSpaces[${payload.WorkSpaceId}].Projects[${indexToInsertOrUpdate}]`, payload, {
            checkExistence: false,
            checkEqual: true
        });
    },
    [workSpacesActionTypes.DELETE_WORK_SPACE_COMPLETED]: (state, { meta }) => set(state, `[${NAMESPACE}].workSpaces`, omit(state[NAMESPACE].workSpaces, meta.workSpaceId), {
        checkExistence: false,
        checkEqual: false
    }),
    [projectsActionTypes.DELETE_PROJECT_COMPLETED]: (state, { meta }) => {
        var _a, _b;
        return set(state, `[${NAMESPACE}].workSpaces[${meta.workSpaceId}].Projects`, reject((_b = (_a = state[NAMESPACE].workSpaces) === null || _a === void 0 ? void 0 : _a[meta.workSpaceId]) === null || _b === void 0 ? void 0 : _b.Projects, ["Id", meta.projectId]), {
            checkExistence: true,
            checkEqual: false
        });
    }
});
